import { MediaType } from '@/types';

import type { ContentFile, FlowMedia } from '@/types';

const generateUUID = (): string => {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

type CreateContentFileParams = {
  media: FlowMedia;
  fileName?: string;
};

const createContentFile = ({
  media,
  fileName = '',
}: CreateContentFileParams): { contentFile: ContentFile } => {
  const { type, width, height, url, driveUid, poster } = media;
  const isVideo = type === MediaType.VIDEO;
  const isAudio = type === MediaType.AUDIO;

  const contentFile: ContentFile = {
    url,
    name: fileName,
    isLoading: false,
    uuid: driveUid || generateUUID(),
    type: type?.toUpperCase() as MediaType,
    preview: {
      width,
      height,
      url: isVideo && poster ? poster : isAudio ? undefined : url,
    },
  };

  return { contentFile };
};

export default createContentFile;
